<template>
    <div>
        <!-- <v-text-field
            ref="input"
            v-model="formattedPrice"
            v-bind="$attrs"
        >

        </v-text-field> -->

        <span :class="showKeyboard ? 'active' : ''" class="pm-price-input-value" @click="(event) => activate(event)">{{ formattedPrice }}</span>

        <div @click="(event) => clickOutside(event)" v-if="showClickTrap" style="s-pointer-events: none; z-index: 9; position: fixed; left: 0; top: 0; right: 0; bottom: 0; background: rgba(255,255,255,0);" />

        <transition :name="keyboardShown ? '' : 'pm-fade-in-slide-up-transition'">
            <pm-numeric-keyboard maxLength="9" v-if="showKeyboard" :value="value" @input="onInput" @close="closeKeyboard"/>
        </transition>
    </div>
</template>

<style>
    .pm-price-input-value {
        line-height: 39px;
        margin-top: 12px;
        display: inline-block;
        border-bottom: 2px solid #949494;
        text-align: right;
        width: 90px;
        max-width: 90px;
        margin-left: 12px;
        position: relative;
    }

    .pm-price-input-value.active {
        border-bottom: 2px solid blue;
        color: blue;
        font-weight: 600;
        padding-right: 3px;
    }
    .pm-price-input-value.active:after {
        position: absolute;
        content: "";
        right: 0;
        top: 10px;
        width: 2px;
        background: blue;
        height: 20px;
        animation: blinker 1s linear infinite;
    }

    @keyframes blinker {
  50% {
    opacity: 1;
  }
}
</style>

<script>
import { scrollElementToTop } from "../../utils/user-interface";

export default {
    name: "PmPriceInput",
    props: {
        value: {
            type: Number,
            default: () => 0,
            required: true,
        }
    },
    data: () => ({
        showKeyboard: false,
        showClickTrap: false,
        price: 0,
        formattedPrice: "0",
        keyboardShown: window.isPmNumericKeyboardShown === true,
    }),

    created() {
        this.formattedPrice = this.getFormattedPrice(this.value);
    },
    methods: {
        closeKeyboard() {
            this.showClickTrap = false;
            this.showKeyboard = false;
        },
        clickOutside(event) {
            this.showClickTrap = false;
            this.$nextTick(() => {
                const el = document.elementFromPoint(event.clientX, event.clientY);
                if (!el.classList.contains('pm-price-input-value')) window.isPmNumericKeyboardShown = false;
                this.showKeyboard = false;
                el.click();
            });
        },
        getFormattedPrice(price) {

            if (typeof price === "undefined" || price === 0 || price === "") {
                return 0;
            }

            price = this.addThousandSeparator(price.toString().replace(",", "."));
            return price;
        },
        onInput(value) {
            this.formattedPrice = this.getFormattedPrice(value);
            this.$emit('input', parseFloat(value));
        },
        activate(event) {
            if (this.showKeyboard) return;
            this.keyboardShown = window.isPmNumericKeyboardShown;
            this.showClickTrap = true;

            scrollElementToTop(event.target, 0);

            const timer = window.softKeyboardShown ? 500 : 0;

            window.setTimeout(() => {
                this.showKeyboard = true;
                window.isPmNumericKeyboardShown = true;
                this.$emit('click');
            }, timer);
        },
        handleDecimals(n) {
            return Number.isInteger(n) ? parseInt(n) : n.toFixed(this.settings.decimals);
        },
        addThousandSeparator(n) {
            const nStr = n.toString();
            const remainder = nStr.length % 3;

            let formatted = (nStr.substr(0, remainder) + nStr.substr(remainder).replace(/(\d{3})/g, ' ' + "$1")).trim();

            if (formatted[0] === ' ') {
                formatted = formatted.substr(1);
            }

            return formatted;
        },
        formatPrice(price) {
            let n = this.value;

            n = Number(parseFloat(n).toFixed(4) + 0);

            return this.addThousandSeparator(this.handleDecimals(n));
        },
    }
};
</script>
